import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  listItemSelector: '[data-comp-capability-list-item]',
  listItemTextSelector: '[data-comp-capability-list-item-text]',
  defaultObserverOptions: {
    rootMargin: '0px',
    threshold: 0.2,
  },
};

export default class AnimationController extends Component {
  static selector = '[data-comp-capability-list-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.capabilities = containerEl.querySelectorAll(options.listItemSelector);
    this.mount();
  }

  observeList() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateDropdownList();
        }
      });
    }, this.$options.defaultObserverOptions);

    observer.observe(this.$container);
  }

  revealItem(listItemEl) {
    listItemEl.classList.add('reveal', 'reveal--no-border');
  }

  animateDropdownList() {
    this.capabilities.forEach((capability, i) => {
      const stagger = i * 150;
      setTimeout(() => {
        this.revealItem(capability);
      }, stagger);
    });
  }

  mount() {
    this.observeList();
  }
}
